import useApiMutation from '_api/mutations/useApiMutation';
import { Exercise, ExercisePayload } from '_api/types';

export const UPDATE_EXERCISE_KEY = 'update-exercise-key';

export const useUpdateExercise = () => {
  return useApiMutation<Exercise, ExercisePayload>(
    () => '/exercise',
    'put',
    {},
    {
      mutationKey: [UPDATE_EXERCISE_KEY],
    },
  );
};
